import React from "react";
import { View } from "react-native";
import { FlexGrid, theme, Text, Panel } from "@clearabee/ui-library-native";
import { useTranslation } from "react-i18next";
import { ThreeTrees } from "components/Icons/ThreeTrees";
import { CarbonNeutral } from "components/Icons/CarbonNeutral";
import { styles, ids } from "./DashboardInfo.styles";

export const DashboardInfo = () => {
  const [translate] = useTranslation();
  return (
    <FlexGrid
      rowSpacing="xsmall"
      cellSpacing="xsmall"
      style={styles.panelsWrapper}
      dataSet={{ media: ids.panelsWrapper }}
    >
      <FlexGrid.Cell base="100%" medium="50%">
        <Panel
          color="positive"
          styles={{
            overflow: "visible",
          }}
        >
          <View style={styles.stickIcon} dataSet={{ media: ids.stickIcon }}>
            <ThreeTrees />
          </View>
          <Text styles={styles.panelText} dataSet={{ media: ids.panelText }}>
            {translate("hwa.components.accountFaq.plantedTrees")}
          </Text>
        </Panel>
      </FlexGrid.Cell>
      <FlexGrid.Cell base="100%" medium="50%">
        <Panel color="warning" styles={{ overflow: "visible" }}>
          <View
            style={[styles.stickIcon, { marginTop: theme.spacing.small }]}
            dataSet={{ media: ids.stickIcon }}
          >
            <CarbonNeutral />
          </View>
          <Text styles={styles.panelText} dataSet={{ media: ids.panelText }}>
            {translate("hwa.components.accountFaq.carbonNeutral")}
          </Text>
        </Panel>
      </FlexGrid.Cell>
    </FlexGrid>
  );
};
